/**
 * =============================================================================
 * Project: vue-boilerplate
 * Created Date: 2017-10-26, 11:38:36
 * Author: Michał Rejman <michal.rejman@telestrada.pl>
 * =============================================================================
 * Last Modified: 2017-11-07, 15:13:42
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */


import { mapActions } from 'vuex';

// COMPONENT ///////////////////////////////////////////////////////////////////
const Component = {
  name: 'HeaderMain',
  components: {},
  props: ['loginLoading'],

  methods: {
    ...mapActions(['logOut', 'toggleLogoutLoading']),
    submitLogOut() {
      this.toggleLogoutLoading();
      this.logOut();
      setTimeout(() => {
        this.$router.push('/');
        this.toggleLogoutLoading();
      }, 2000);
    },
  },
};

// EXPORT COMPONENT ////////////////////////////////////////////////////////////
export default Component;



// WEBPACK FOOTER //
// ./src/components/Panel/HeaderContainer/HeaderMain/component.js